import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, DateRangeQueryPicker, QueryDropdown, BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function ImportListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        rangeQueryPickerStore,
        userStore,
        facilityStore,
        importStatusStore,
        routes,
        rootStore,
        authorization,
        validationReportUrl
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
           <PageNavigation>
            {validationReportUrl ? <a className="btn btn--base btn--ghost" href={validationReportUrl}><i className="u-icon u-icon--sml u-icon--download-btn"></i>Validation Report</a> : null}
            <BaasicButton 
                className="btn btn--base btn--primary" 
                label={'IMPORT.LIST.UPLOAD.BUTTON_TITLE'} 
                icon='u-icon u-icon--sml u-icon--upload--white' 
                onClick={() => routes.create()}
                authorized={rootStore.permissionStore.hasPermission('portalSection.create')}></BaasicButton>
            </PageNavigation>
        <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}>
                        <div className="col col-sml-12 col-med-6 col-lrg-8 col-xxlrg-4 form__group">
                            <DateRangeQueryPicker queryUtility={queryUtility} fromPropertyName="dateFrom" toPropertyName="dateTo" store={rangeQueryPickerStore} timeZone="UTC" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={userStore} propertyName="userId" label="User"/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={importStatusStore} propertyName="statusId" label="Status" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='IMPORT.LIST.EMPTY_STATE.TITLE' description='IMPORT.LIST.EMPTY_STATE.DESCRIPTION' />
}

ImportListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onDelete, onPreview, isAdmin } = actions;
    if (!isSome(onEdit) && !isSome(onDelete) && !isSome(onPreview)) return null;
    return (
        <td className="table__body--data right">
            <div className="table__icons">      
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.PREVIEW'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}            
                {isSome(onEdit) && isAdmin ?  (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}                
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.delete : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.DELETE'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(ImportListTemplate);
